import { concat } from "lodash";

// this function is used to format the number based on the contry currency code
export const numberFormat = (number, classNameCurrency, showZero = false, displayCurrencyLiter = true, syntax = { code: 'SAR', locale: 'en' }) => {
    const { locale } = syntax;
    const lang = localStorage.getItem("i18nextLng");
    const code = lang == 'en' ? ' SR ' : ' ريال ';
    const suffixCode = (locale == 'en' ? 'IN' : 'EG');
    if (number == null || number == undefined || number == 'null' || number == '' || number == '0' || number == 0)
        number = 0;

    if (((number == '0' || number == 0) && showZero == false))
        return null;


    number = parseFloat(number);

    if (displayCurrencyLiter) {
        return concat(Intl.NumberFormat().format(number), classNameCurrency ? <span key={Math.random} className={classNameCurrency}>{code}</span> : code);
    }

    return concat(Intl.NumberFormat().format(number), <span className={classNameCurrency}>{code}</span>);
};